/**
 * Admin User Management — `/admin/users`
 *
 * Search/list users, toggle super-user status, edit name/email, jump to a
 * user's team. Backed by the `adminUsers` tRPC router (extracted from the
 * legacy catch-all `admin` router for 1:1 panel↔router parity per
 * `kit-vidmax-admin/skill.md`).
 */
import { createFileRoute } from "@tanstack/react-router"
import AdminHome from "~/components/Admin/AdminHome"
import CustomHead from "~/components/SEOHead/CustomHead"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"

import type { ReactElement } from "react"
function AdminHomepage() {
  return (
    <>
      <CustomHead />

      <div>
        <AdminHome />
      </div>
    </>
  )
}

function AdminHomepageWrapper() {
  return (
    <SuperAdminLayout>
      <AdminHomepage />
    </SuperAdminLayout>
  )
}

export const Route = createFileRoute("/admin/users")({
  component: AdminHomepageWrapper,
})
